/*!
 * Copyright © 2025 Actavivo
 */
import * as AV from "./Interfaces/AV.Interfaces";
import { Server } from "../Platform/Server";

/** Base API client: holds the root API prefix and provides getFk() and getURLLink() utilities shared across all domain API classes. */
export class AVBase {
	static _api = "/api/";
	static _baseApi = "/api/Base";
	public static getFk(obj: AV.IAVBase): AV.IFK {
		return { pk: obj.pk, id: obj.id, region: obj.region, type: obj.type };
	}

	public static async getURLLink(urlLink: AV.IURLLink): Promise<AV.IURLLink> {
		return await Server.post<AV.IURLLink>(this._baseApi + "/GetLink", urlLink);
	}
}
